<template>
    <el-dialog
        :title="dialogTitle"
        :visible="visible"
        class="prop info-tips"
        width="650px"
        :before-close="closeDialog"
    >
        <div class="investor-tips">
            <div v-if="!isResPage">
                <el-form
                    ref="ruleForm"
                    class="two-cols-form mt-20px color-999"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="120px"
                    size="small"
                    v-on:submit.native.prevent
                >
                    <el-form-item label="当前预留信息：">
                        <div class="ml-15">
                            {{ currentRemark ? currentRemark : "未设置" }}
                        </div>
                    </el-form-item>
                    <el-form-item label="修改预留信息：" prop="remark" class="mt-20px">
                        <el-input
                            v-model.trim="ruleForm.remark"
                            class="w-80"
                            type="text"
                            :maxlength="16"
                            placeholder="请输入16个字符以内的信息"
                        />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer mt-20px">
                    <div class="warn-tip-contain">
                        <div class="warn-tip-text">
                            温馨提示：请记住您设置的预留信息，该信息将在您登录网上交易系统置顶栏显示，若该页面未能正确显示您的预留信息，请及时联系客服热线{{
                                $cache.getCompanyInfoParam("10101009")
                            }}进行确认。
                        </div>
                    </div>
                    <div class="btn-box">
                        <el-button
                            type="primary"
                            class="add-btn"
                            :loading="submitting"
                            v-on:click="submit"
                        >
                            确认
                        </el-button>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="result-contain">
                    <div>
                        <img src="../../assets/img/success.png" alt="" />
                    </div>
                    <div class="result-text">预留信息{{ typeLabel }}成功!</div>
                </div>
                <div class="btn-box">
                    <el-button type="primary" class="add-btn" v-on:click="closeDialog">
                        确认
                    </el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import userApi from "@/api/user";

export default {
    name: "RemarkDialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        currentRemark: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            submitting: false,
            isResPage: false,
            typeLabel: "修改",
            ruleForm: {
                remark: ""
            },
            rules: {
                remark: [{ required: true, message: "请输入预留信息", trigger: "change" }]
            }
        };
    },
    computed: {
        dialogTitle() {
            return this.typeLabel + "预留信息";
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.ruleForm.remark = "";
                this.isResPage = false;
                this.typeLabel = this.currentRemark && this.currentRemark.trim() ? "修改" : "新增";
                this.$nextTick(() => {
                    if (this.$refs.ruleForm) {
                        this.$refs.ruleForm.clearValidate();
                    }
                });
            }
        }
    },
    methods: {
        closeDialog() {
            this.isResPage = false;
            this.$emit("close");
        },
        submit() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (!valid) return;
                this.submitting = true;
                try {
                    const remark = this.ruleForm.remark;
                    const res = await userApi.updRemark({ remark });
                    if (res.code == "0") {
                        const info = Object.assign({}, this.$cache.getUser(), { remark });
                        // 预留信息在当前页弹窗内完成，成功后只刷新用户缓存，避免纯代销用户落到账户安全页。
                        this.$store.dispatch("setInfo", info);
                        this.$emit("success", info);
                        this.isResPage = true;
                    }
                } finally {
                    this.submitting = false;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    padding: 10px !important;
}
::v-deep .el-dialog__headerbtn {
    top: 0 !important;
}
::v-deep .el-form-item__label {
    color: #999999 !important;
}
.mt-20px {
    margin-top: 20px;
}
.ml-15 {
    margin-left: 15px;
}
.w-80 {
    width: 80%;
}
.color-999 {
    color: #999999;
}
.btn-box {
    text-align: center;
    margin-top: 10px;
    cursor: pointer;
    .add-btn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: var(--color-primary);
        border: 1px solid var(--color-primary);
        color: #ffffff;
    }
}
.warn-tip-contain {
    line-height: 20px;
    padding: 10px 20px 10px;
    .warn-tip-text {
        text-indent: 2em;
        margin-top: 6px;
        color: #999999;
    }
}
.result-contain {
    background-color: rgb(250, 250, 250);
    width: 100%;
    text-align: center;
    padding-top: 50px;
    padding-bottom: 30px;
    margin-top: 30px;
}
.result-text {
    font-weight: bold;
    margin-top: 20px;
    font-size: 18px;
}
</style>
